import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AccountDetailsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AccountDetailsPage";
import Classes, { Account } from "model";

export default function CaptureAccountsCheckEntered(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const showConsumerAccounts = Account.hasConsumerAccounts(branding);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "searchAccordion", "isActive" ], true)
        .update([ "searchByCheck" ], true)
        .submit();

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "search", "amount" ], showConsumerAccounts ? "10.00" : "1500")
        .update([ "search", "check" ], showConsumerAccounts ? "2312" : "9553")
        .submit();

    return <AccountDetailsPage ui={ ui } data={ data } />
}